module.exports = __webpack_public_path__ + "f2c716b969ad2dba1de5e2064a548dc0.jpg";